import ApiClient from '@api/client'

const client = new ApiClient({ path: '/audience-contacts' })

export const ContactsService = {
  /**
   * Create Contact
   * @param {Object} data
   */
  async create (data) {
    return await client.post('', data)
  },
  /**
   * Get Contact By Id
   * @return {Array} contacts
   */
  async getById (id) {
    return await client.get(`/${id}`)
  },
  /**
   * Delete Contact
   * @param {Number|String} id
   */
  async delete (id) {
    return await client.delete(`/${id}`)
  },
  /**
   * Uptade Contact
   * @param {Number|String} id
   * @param {Object} data
   */
  async update (id, data) {
    return await client.put(`/${id}`, data)
  },
}
